<template>
  <div id="dashboard">
    <v-alert v-if="user.publisher_message" dismissible rounded dark color="blue darken-3">
      {{user.publisher_message}}
    </v-alert>
    <portal to="toolbarMenuContent">
      <v-tooltip :value="isWebsiteTooltipVisible" right allow-overflow color="primary" content-class="left">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="display === 'overview'" icon @click="changeUI('sites')">
            <v-icon>mdi-folder-multiple</v-icon>
          </v-btn>
          <v-btn v-else icon @click="changeUI('overview')">
            <v-icon>mdi-view-dashboard</v-icon>
          </v-btn>
        </template>

        <div class="d-inline">
          <span class="pic arrow-left"></span>
          <span>Qui puoi filtrare per sito e placement</span>
          <!--  <v-btn text small color="default" @click="dismissTooltip('website')"> chiudi</v-btn>-->
        </div>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-autocomplete
          v-if="display === 'sites'"
          class="mt-4"
          v-model="filters.website"
          :items="websites"
          :search-input.sync="filters.search"
          color="primary"
          hide-no-data
          hide-selected
          item-text="domain"
          item-value="id"
          placeholder="Seleziona un sito"
          prepend-icon="mdi-web"
          return-object
      ></v-autocomplete>
      <v-spacer></v-spacer>


      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-btn v-if="display === 'sites' && filters.website" icon @click="openPlacementsDrawer">
          <v-tooltip :value="isPlacementTooltipVisible"
                     bottom
                     nudge-bottom="15"
                     nudge-left="90"
                     allow-overflow
                     color="primary"
                     content-class="right">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="small-icon">mdi-image-size-select-large</v-icon>
            </template>
            <div class="d-inline">
              <!--                <span v-if="display !== 'sites' || !filters.website" class="pic arrow-right"></span>-->
              <span class="pic arrow-top right"></span>
              <!--          <v-btn text small color="default" @click=""> chiudi</v-btn>-->
              <span>Qui puoi filtrare per placement</span>
            </div>
          </v-tooltip>

        </v-btn>
        <!--        <v-btn v-if="display === 'sites' && filters.website" icon @click="openPlacementsDrawer">-->
        <!--          <v-tooltip :value="isPlacementTooltipVisible"-->
        <!--                     bottom-->
        <!--                     allow-overflow-->
        <!--                     color="primary"-->
        <!--                     content-class="right">-->
        <!--            <template v-slot:activator="{ on, attrs }">-->
        <!--              <v-icon class="small-icon">fa-hashtag</v-icon>-->
        <!--            </template>-->
        <!--            <div class="d-inline">-->
        <!--              <span class="pic arrow-top"></span>-->
        <!--              &lt;!&ndash;            <v-btn text small color="default" @click=""> chiudi</v-btn>&ndash;&gt;-->
        <!--              <span>Qui puoi filtrare per placement</span>-->
        <!--            </div>-->
        <!--          </v-tooltip>-->
        <!--        </v-btn>-->
      </template>
      <template v-else>
        <v-btn v-if="display === 'sites' && filters.website" icon @click="openPlacementsDrawer">
          <v-tooltip :value="isPlacementTooltipVisible" left allow-overflow color="primary" content-class="right"
                     nudge-left="15">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="small-icon">mdi-image-size-select-large</v-icon>
            </template>
            <div class="d-inline">
              <span class="pic arrow-right"></span>
              <!--            <v-btn text small color="default" @click=""> chiudi</v-btn>-->
              <span>Qui puoi filtrare per placement</span>
            </div>
          </v-tooltip>
        </v-btn>
      </template>


      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-btn icon @click="openSettingsDrawer">
          <template v-if="display === 'sites' && filters.website!==undefined">
            <v-icon>mdi-image-multiple</v-icon>
          </template>
          <template v-else>
            <v-tooltip :value="isFormatTooltipVisible"
                       bottom
                       allow-overflow
                       color="primary"
                       content-class="right">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="openSettingsDrawer">
                  <v-icon>mdi-image-multiple</v-icon>
                </v-btn>
              </template>
              <div class="d-inline">
                <!--  <span v-if="display !== 'sites' || !filters.website" class="pic arrow-right"></span>-->
                <span class="pic arrow-top right"></span>
                <!--     <v-btn text small color="default" @click=""> chiudi</v-btn>-->
                <span>Qui puoi filtrare per formato</span>
              </div>
            </v-tooltip>
          </template>
        </v-btn>
      </template>
      <template v-else>
        <v-tooltip :value="isFormatTooltipVisible"
                   :bottom="display === 'sites' && filters.website!==undefined"
                   :left="display !== 'sites' || !filters.website" allow-overflow color="primary"
                   content-class="right">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openSettingsDrawer">
              <v-icon>mdi-image-multiple</v-icon>
            </v-btn>
          </template>
          <div class="d-inline">
            <span v-if="display !== 'sites' || !filters.website" class="pic arrow-right"></span>
            <span v-else class="pic arrow-top right"></span>
            <!--          <v-btn text small color="default" @click=""> chiudi</v-btn>-->
            <span>Qui puoi filtrare per formato</span>
          </div>
        </v-tooltip>
      </template>

    </portal>
    <v-snackbar v-model="snackbar" :timeout="0" :color="snackbar_color" top class="alert">
      {{ responseError }}
      <v-btn class="snackbar_btn" text @click="snackbar = false">
        <span>Chiudi</span>
      </v-btn>
    </v-snackbar>

    <!-- Filtro Ad Unit Type -->
    <div v-if="filters.adUnitType">
      <v-chip class="ma-2">
        Stai visualizzando i dati relativi al formato:
        <span class="text-uppercase">{{ selectedAdUnitTypeName }}</span>
      </v-chip>
    </div>


    <div v-if="display === 'overview'" class="overview">
      <overview
          v-if="reports"
          :reports="reports"
          :show-graphs="showGraphs"
          :ad-unit-type="websiteStatsAdUnitType"
          v-on:dialogRevenueChanged="dialogRevenueChanged"
          v-on:dialogCPMChanged="dialogCPMChanged"
      ></overview>
    </div>
    <div v-else class="detail">
      <WebsiteStats
          v-if="reports && reports.website"
          :show-graphs="showGraphs"
          :website="filters.website"
          :ad-unit="websiteStatsAdUnit"
          :ad-unit-type="websiteStatsAdUnitType"
          :reports="websiteStatsReport"
          v-on:dialogRevenueChanged="dialogRevenueChanged"
          v-on:dialogCPMChanged="dialogCPMChanged"
      ></WebsiteStats>
    </div>

    <!--Start Strumenti ZOOM -->
    <!--Strumenti Zoom REVENUE -->
    <v-row>
      <v-dialog
          v-model="dialogRevenue"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogRevenue = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Dettaglio Revenue</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogRevenue = false"
              >
                Chiudi
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <div v-if="display === 'overview'" class="overview">
            <OverviewDetailRevenue
                v-if="reports"
                :reports="reports"
                :show-graphs="showGraphs">
            </OverviewDetailRevenue>
          </div>
          <div v-else class="detail">
            <WebsiteStatsRevenue
                v-if="reports && reports.website"
                :show-graphs="showGraphs"
                :website="currentWebsite"
                :ad-unit="websiteStatsAdUnit"
                :reports="websiteStatsReport">

            </WebsiteStatsRevenue>
          </div>

        </v-card>
      </v-dialog>
    </v-row>

    <!--Strumenti Zoom CPM -->
    <v-row>
      <v-dialog
          v-model="dialogCPM"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogCPM = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Dettaglio CPM</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogCPM = false"
              >
                Chiudi
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <div v-if="display === 'overview'" class="overview">
            <OverviewDetailCPM
                v-if="reports"
                :reports="reports"
                :show-graphs="showGraphs"></OverviewDetailCPM>
          </div>
          <div v-else class="detail">
            <WebsiteStatsCPM
                v-if="reports && reports.website"
                :show-graphs="showGraphs"
                :website="currentWebsite"
                :ad-unit="websiteStatsAdUnit"
                :reports="websiteStatsReport"></WebsiteStatsCPM>
          </div>

        </v-card>
      </v-dialog>
    </v-row>
    <!--END Strumenti Zoom -->


    <v-dialog v-model="dialogs.period.visible" persistent>
      <base-material-card icon="mdi mdi-calendar" color="primary" light class="w-100 px-5 py-3">
        <template v-slot:after-heading>
          <h2>Seleziona un periodo</h2>
        </template>
        <v-date-picker v-model="filters.period"
                       :max="dialogs.reportRequest.calendar.max"
                       range
                       first-day-of-week="1"
                       :selected-items-text="reportRequestHeaderFormat"
                       locale="it-it"
                       :landscape="$vuetify.breakpoint.mdAndUp"
                       :show-current="true"
                       full-width

        ></v-date-picker>
        <v-card-actions>
          <v-btn color="default darken-1" text @click="dialogs.period.visible = false">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="query">Applica</v-btn>
        </v-card-actions>
      </base-material-card>
    </v-dialog>


    <v-tooltip :value="isReportPeriodTooltipVisible" top allow-overflow color="primary" nudge-bottom="-15">
      <template v-slot:activator="{ on, attrs }">
        <v-btn style="margin-bottom:60px;" app dark fab fixed bottom right color="primary"
               @click="openReportPeriodDialog">
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
      </template>
      <div class="d-inline">
        <span class="pic arrow-bottom right"></span>
        <!--        <v-btn text small color="default" @click=""> chiudi</v-btn>-->
        <span>Qui puoi selezionare una data o un periodo</span>
      </div>
    </v-tooltip>

    <v-btn app dark fab fixed bottom right color="rgb(0, 159, 76)"
           @click="downloadReportExcel">
      <v-icon style="height: 18px; font-size: 18px; width: 18px;">fa-file-excel</v-icon>
    </v-btn>

    <v-navigation-drawer v-model="drawers.settings.visible" fixed temporary right app>
      <v-list nav>
        <v-subheader>Formato</v-subheader>
        <v-list-item-group v-model="filters.adUnitType" color="primary">
          <v-list-item>
            <v-list-item-title>Tutti</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Display</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Native</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Video</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>AMP</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="drawers.placements" fixed temporary right app>
      <v-list nav v-if="currentWebsite">
        <v-subheader>Placement</v-subheader>
        <v-list-item-group v-model="filters.adUnit" color="primary">
          <v-list-item>
            <v-list-item-title>Tutti</v-list-item-title>
          </v-list-item>
          <v-list-item v-for="adUnit in currentWebsite.ad_units" :key="adUnit.id">
            <v-list-item-title>{{ adUnit.placement }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import moment from 'moment/moment'
import 'moment/locale/it'
import Overview from './dashboard/Overview'
import WebsiteStats from './dashboard/WebsiteStats'
import OverviewDetailCPM from "./dashboard/OverviewDetailCPM"
import OverviewDetailRevenue from "./dashboard/OverviewDetailRevenue"
import WebsiteStatsCPM from "./dashboard/WebsiteStatsCPM"
import WebsiteStatsRevenue from "./dashboard/WebsiteStatsRevenue"
import {mapGetters} from 'vuex'
import router from '@/router'

moment.locale('it')

const AD_UNIT_TYPES = ['all', 'display', 'native', 'video', 'amp']

export default {
  name: 'Dashboard',
  components: {
    WebsiteStats,
    Overview,
    OverviewDetailCPM,
    OverviewDetailRevenue,
    WebsiteStatsCPM,
    WebsiteStatsRevenue,
  },
  data: () => ({
    // AD_UNIT_TYPES: [],
    selectedAdUnitTypeName: null,
    dialogCPM: false,
    dialogRevenue: false,
    dialogPages: false,
    notifications: false,
    sound: true,
    widgets: false,
    show: true,
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: true,
      }
    ],
    dialogs: {
      reportRequest: {
        visible: true,
        calendar: {
          date: moment().subtract(1, 'day').toISOString().substr(0, 10),
          max: moment().subtract(1, 'day').toISOString().substr(0, 10),
        }
      },
      period: {
        visible: false,
      }
    },
    reports: undefined,
    display: 'overview',
    drawers: {
      settings: {
        visible: false
      },
      placements: false,
    },
    filters: {
      period: [
        moment().subtract(7, 'day').toISOString().substr(0, 10),
        moment().subtract(1, 'day').toISOString().substr(0, 10),
      ],
      adUnitType: 1,
      adUnit: 0,
      website: undefined,
      search: undefined
    },
    websites: [],
    currentWebsite: undefined,
    snackbar: false,
    responseError: '',
    snackbar_color: '#db2f2f',
      user:null,
  }),
  watch: {
    async 'filters.website'(val) {
      await axios.get('website/' + val.id).then(response => {
        let index = this.websites.findIndex((item) => {
          return item.id === val.id
        })
        this.websites.splice(index, 1, response.data)

        this.currentWebsite = this.websites[index]
      })
      //query data
      this.query()
    },
    'filters.adUnitType'(val) {
      //query data
      this.query()
    },
    'filters.adUnit'(val) {
      //query data
      this.query()
    },
    display() {
      this.query()
    }
  },
  computed: {
    ...mapGetters([
      'isReportPeriodTooltipVisible',
      'isWebsiteTooltipVisible',
      'isFormatTooltipVisible',
      'isPlacementTooltipVisible',
    ]),
    websiteStatsReport() {
      return this.reports.ad_unit ? this.reports.ad_unit : this.reports.website
    },
    websiteStatsAdUnit() {
      return this.filters.adUnit ? this.currentWebsite.ad_units[this.filters.adUnit - 1] : null
    },
    websiteStatsAdUnitType() {
      return this.filters.adUnitType
    },
    showGraphs() {
      return this.filters.period[1] !== undefined && this.filters.period[0] !== this.filters.period[1]
    },
    reportRequestHeaderFormat() {
      let startDate = moment(this.filters.period[1])
      let endDate = moment(this.filters.period[0])

      let str = ''
      if (this.filters.period.length === 2) {
        if (startDate > endDate) {
          let tmp = startDate
          startDate = endDate
          endDate = tmp
        }

        str += '<p>' + startDate.format('ddd DD MMM') + '</p>'
        str += '<p>' + endDate.format('ddd DD MMM') + '</p>'
      }
      return str
    }
  },
  methods: {
    changeUI(display) {
      this.display = display
      this.$store.dispatch('dismissTooltip', 'website')
    },
    // dismissTooltip(key){
    //   this.$store.dispatch("dismissTooltip",key)
    // },
    openReportPeriodDialog() {
      this.dialogs.period.visible = true
      this.$store.dispatch('dismissTooltip', 'reportPeriod')
    },
    openSettingsDrawer() {
      this.drawers.settings.visible = true
      this.$store.dispatch('dismissTooltip', 'format')
    },
    openPlacementsDrawer() {
      this.drawers.placements = true
      this.$store.dispatch('dismissTooltip', 'placement')
    },
    query() {
      let _URLSearchParams = new URLSearchParams()
      let startDate = this.filters.period[1]
      let endDate = this.filters.period[0]

      if (this.filters.period.length === 1) {
        startDate = this.filters.period[0]
      }

      //compute the start end based on max
      if (moment(startDate) > moment(endDate)) {
        let tmp = startDate
        startDate = endDate
        endDate = tmp
      }

      let query = {
        range: startDate + ',' + endDate
      }

      if (this.filters.adUnitType) {
        this.selectedAdUnitTypeName = AD_UNIT_TYPES[this.filters.adUnitType]; // Set AdUniTName For frontend filter
        query.type = AD_UNIT_TYPES[this.filters.adUnitType]
      }

      if (this.filters.adUnit) {
        query.ad_unit = this.currentWebsite.ad_units[this.filters.adUnit - 1].id
      }

      if (this.display === 'sites') {

        if (this.filters.website) {
          query.website = this.filters.website.id
        }
      }

      Object.keys(query).forEach((parameterName) => {
        _URLSearchParams.append(parameterName, query[parameterName])
      })

      this.$store.dispatch('reports', _URLSearchParams.toString()).then(response => {
        this.reports = response.data
      }).catch(error => {
        console.log('Error get reports', error)

      })

      this.dialogs.period.visible = false
    },
    downloadReportExcel() {
      //Webiste mandatory
      if (!this.filters.website) {
        alert("Specificare un sito per il download del report.");
        return;
      }
      console.log("YB downloadReportExcel ...");
      console.log(this.filters);

      //Website
      var website = this.filters.website.id;

      //Range
      var start = this.filters.period[0];
      var end = this.filters.period[1];

      //AdUnits
      if (this.filters.adUnit != 0) {
        var adUnit = this.currentWebsite.ad_units[this.filters.adUnit - 1].id;
      } else {
        var adUnit = 0;
      }

      //adUnitType
      var adUnitType = this.filters.adUnitType;

      //Prevent error on single selection
      if (start == null) {
        start = end;
      }
      if (end == null) {
        end = start;
      }

      //Send Request
      axios({
        url: '/reports/download?start=' + start + '&end=' + end + '&website=' + website + '&adUnit=' + adUnit + '' + '&adUnitType=' + adUnitType + '',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', this.filters.website.domain + '-' + moment(start).format("MM/DD/YYYY") + '-' + moment(end).format("MM/DD/YYYY") + '-yb-Report.xlsx');
            document.body.appendChild(fileLink);
            fileLink.click();
          }
      );

    },
    dialogRevenueChanged: function () {
      console.log("Update value dialogRevenue PARENT")
      this.dialogRevenue = true;
    },
    dialogCPMChanged: function () {
      console.log("Update value dialogCPM PARENT")
      this.dialogCPM = true;
    }
  },
  mounted() {
    this.query()
    this.$store.dispatch('websites').then(response => {
      this.websites = response.data
      this.websites.forEach((website, index) => {
        if (!website.ads_txt_validated) {
          this.responseError = 'Il tuo file ADS.txt non è aggiornato su uno o più siti. Copia le nuove stringhe dalla sezione Account e incollale nel file ADS.txt di ciascun sito per non rinunciare a nuove possibilità di monetizzazione.'
          this.snackbar = true
          return
        }
      })
    }).catch(error => {
        //In case of errors 401
        this.$store.commit('logout')
        this.$router.replace('/login')
        console.log('Error get websites ', error)
    })

      this.$store.dispatch('me').then(response => {
          this.user = response.data
      }).catch(error => {
          this.$store.commit('logout')
          this.$router.replace('/login')
          console.log('ERRORE!', error)
      })

  }
}
</script>

<style scoped lang="scss">
.v-btn-toggle {
  .v-btn {
    margin-bottom: 0 !important;
  }
}

.snackbar_btn span {
  color: #323232;
}

.small-icon {
  width: 17px !important;
  height: 17px !important;
}


.pic {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  position: absolute;
}

.arrow-left {
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  border-right: 16px solid #3682d8;
  left: -16px;
  top: 0;
}

.arrow-right {
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  border-left: 16px solid #3682d8;
  top: 0;
  right: -16px;
  /*border-right: 16px solid #000;*/
}

.arrow-bottom {
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #3682d8;
  bottom: -16px;
  right: 14px;
  /*border-right: 16px solid #000;*/
}

.arrow-top {
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #3682d8;
  top: -16px;
  right: 0px;
  /*border-right: 16px solid #000;*/
}

.v-tooltip__content {
  z-index: 6 !important;
}

.v-tooltip__content {
  &.left {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.v-tooltip__content {
  &.right {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
}

</style>
